import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../config/queryKeys'
import {
  readOrganization,
  type OrganizationDetails,
} from '../services/organization/readOrganization'

/**
 * Reads a single organization. Used by the Operations tab because the roster
 * permission helpers need `sync_salesforce`, which the competition tree does
 * not include.
 */
export const useOrganization = (organizationId?: string) => {
  'use memo'

  const query = useQuery({
    queryKey: queryKeys.organizations.byId(organizationId ?? ''),
    queryFn: () => readOrganization(organizationId as string),
    enabled: Boolean(organizationId),
    staleTime: 5 * 60 * 1000,
  })

  const organization: OrganizationDetails | null = query.data ?? null

  return { organization, isLoading: query.isLoading }
}
